import { p as $ } from "./index-xuotMAFm.mjs";
import { c as fe, d as Ce } from "./index-DhidOF4D.mjs";
var Et = { exports: {} }, ve = typeof Reflect == "object" ? Reflect : null, Ft = ve && typeof ve.apply == "function" ? ve.apply : function(t, r, o) {
  return Function.prototype.apply.call(t, r, o);
}, Te;
ve && typeof ve.ownKeys == "function" ? Te = ve.ownKeys : Object.getOwnPropertySymbols ? Te = function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Te = function(t) {
  return Object.getOwnPropertyNames(t);
};
function qr(e) {
  console && console.warn && console.warn(e);
}
var dr = Number.isNaN || function(t) {
  return t !== t;
};
function G() {
  G.init.call(this);
}
Et.exports = G;
Et.exports.once = Vr;
G.EventEmitter = G;
G.prototype._events = void 0;
G.prototype._eventsCount = 0;
G.prototype._maxListeners = void 0;
var Ut = 10;
function Fe(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(G, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Ut;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || dr(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    Ut = e;
  }
});
G.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
G.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || dr(t))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
  return this._maxListeners = t, this;
};
function pr(e) {
  return e._maxListeners === void 0 ? G.defaultMaxListeners : e._maxListeners;
}
G.prototype.getMaxListeners = function() {
  return pr(this);
};
G.prototype.emit = function(t) {
  for (var r = [], o = 1; o < arguments.length; o++) r.push(arguments[o]);
  var a = t === "error", f = this._events;
  if (f !== void 0)
    a = a && f.error === void 0;
  else if (!a)
    return !1;
  if (a) {
    var c;
    if (r.length > 0 && (c = r[0]), c instanceof Error)
      throw c;
    var d = new Error("Unhandled error." + (c ? " (" + c.message + ")" : ""));
    throw d.context = c, d;
  }
  var s = f[t];
  if (s === void 0)
    return !1;
  if (typeof s == "function")
    Ft(s, this, r);
  else
    for (var v = s.length, _ = br(s, v), o = 0; o < v; ++o)
      Ft(_[o], this, r);
  return !0;
};
function yr(e, t, r, o) {
  var a, f, c;
  if (Fe(r), f = e._events, f === void 0 ? (f = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (f.newListener !== void 0 && (e.emit(
    "newListener",
    t,
    r.listener ? r.listener : r
  ), f = e._events), c = f[t]), c === void 0)
    c = f[t] = r, ++e._eventsCount;
  else if (typeof c == "function" ? c = f[t] = o ? [r, c] : [c, r] : o ? c.unshift(r) : c.push(r), a = pr(e), a > 0 && c.length > a && !c.warned) {
    c.warned = !0;
    var d = new Error("Possible EventEmitter memory leak detected. " + c.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    d.name = "MaxListenersExceededWarning", d.emitter = e, d.type = t, d.count = c.length, qr(d);
  }
  return e;
}
G.prototype.addListener = function(t, r) {
  return yr(this, t, r, !1);
};
G.prototype.on = G.prototype.addListener;
G.prototype.prependListener = function(t, r) {
  return yr(this, t, r, !0);
};
function xr() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function hr(e, t, r) {
  var o = { fired: !1, wrapFn: void 0, target: e, type: t, listener: r }, a = xr.bind(o);
  return a.listener = r, o.wrapFn = a, a;
}
G.prototype.once = function(t, r) {
  return Fe(r), this.on(t, hr(this, t, r)), this;
};
G.prototype.prependOnceListener = function(t, r) {
  return Fe(r), this.prependListener(t, hr(this, t, r)), this;
};
G.prototype.removeListener = function(t, r) {
  var o, a, f, c, d;
  if (Fe(r), a = this._events, a === void 0)
    return this;
  if (o = a[t], o === void 0)
    return this;
  if (o === r || o.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete a[t], a.removeListener && this.emit("removeListener", t, o.listener || r));
  else if (typeof o != "function") {
    for (f = -1, c = o.length - 1; c >= 0; c--)
      if (o[c] === r || o[c].listener === r) {
        d = o[c].listener, f = c;
        break;
      }
    if (f < 0)
      return this;
    f === 0 ? o.shift() : Gr(o, f), o.length === 1 && (a[t] = o[0]), a.removeListener !== void 0 && this.emit("removeListener", t, d || r);
  }
  return this;
};
G.prototype.off = G.prototype.removeListener;
G.prototype.removeAllListeners = function(t) {
  var r, o, a;
  if (o = this._events, o === void 0)
    return this;
  if (o.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : o[t] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete o[t]), this;
  if (arguments.length === 0) {
    var f = Object.keys(o), c;
    for (a = 0; a < f.length; ++a)
      c = f[a], c !== "removeListener" && this.removeAllListeners(c);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = o[t], typeof r == "function")
    this.removeListener(t, r);
  else if (r !== void 0)
    for (a = r.length - 1; a >= 0; a--)
      this.removeListener(t, r[a]);
  return this;
};
function gr(e, t, r) {
  var o = e._events;
  if (o === void 0)
    return [];
  var a = o[t];
  return a === void 0 ? [] : typeof a == "function" ? r ? [a.listener || a] : [a] : r ? Hr(a) : br(a, a.length);
}
G.prototype.listeners = function(t) {
  return gr(this, t, !0);
};
G.prototype.rawListeners = function(t) {
  return gr(this, t, !1);
};
G.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : vr.call(e, t);
};
G.prototype.listenerCount = vr;
function vr(e) {
  var t = this._events;
  if (t !== void 0) {
    var r = t[e];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
G.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Te(this._events) : [];
};
function br(e, t) {
  for (var r = new Array(t), o = 0; o < t; ++o)
    r[o] = e[o];
  return r;
}
function Gr(e, t) {
  for (; t + 1 < e.length; t++)
    e[t] = e[t + 1];
  e.pop();
}
function Hr(e) {
  for (var t = new Array(e.length), r = 0; r < t.length; ++r)
    t[r] = e[r].listener || e[r];
  return t;
}
function Vr(e, t) {
  return new Promise(function(r, o) {
    function a(c) {
      e.removeListener(t, f), o(c);
    }
    function f() {
      typeof e.removeListener == "function" && e.removeListener("error", a), r([].slice.call(arguments));
    }
    mr(e, t, f, { once: !0 }), t !== "error" && zr(e, a, { once: !0 });
  });
}
function zr(e, t, r) {
  typeof e.on == "function" && mr(e, "error", t, r);
}
function mr(e, t, r, o) {
  if (typeof e.on == "function")
    o.once ? e.once(t, r) : e.on(t, r);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(t, function a(f) {
      o.once && e.removeEventListener(t, a), r(f);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var At = Et.exports, yt = { exports: {} };
typeof Object.create == "function" ? yt.exports = function(t, r) {
  r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : yt.exports = function(t, r) {
  if (r) {
    t.super_ = r;
    var o = function() {
    };
    o.prototype = r.prototype, t.prototype = new o(), t.prototype.constructor = t;
  }
};
var se = yt.exports, xe, kt;
function wr() {
  return kt || (kt = 1, xe = At.EventEmitter), xe;
}
var Rt = {}, _r = {}, Sr = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, r = Symbol("test"), o = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
    return !1;
  var a = 42;
  t[r] = a;
  for (r in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var f = Object.getOwnPropertySymbols(t);
  if (f.length !== 1 || f[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var c = Object.getOwnPropertyDescriptor(t, r);
    if (c.value !== a || c.enumerable !== !0)
      return !1;
  }
  return !0;
}, Kr = Sr, Ot = function() {
  return Kr() && !!Symbol.toStringTag;
}, Jr = Error, Yr = EvalError, Zr = RangeError, Xr = ReferenceError, Er = SyntaxError, Ue = TypeError, Qr = URIError, $t = typeof Symbol < "u" && Symbol, en = Sr, tn = function() {
  return typeof $t != "function" || typeof Symbol != "function" || typeof $t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : en();
}, Ge = {
  __proto__: null,
  foo: {}
}, rn = Object, nn = function() {
  return { __proto__: Ge }.foo === Ge.foo && !(Ge instanceof rn);
}, on = "Function.prototype.bind called on incompatible ", an = Object.prototype.toString, fn = Math.max, un = "[object Function]", Wt = function(t, r) {
  for (var o = [], a = 0; a < t.length; a += 1)
    o[a] = t[a];
  for (var f = 0; f < r.length; f += 1)
    o[f + t.length] = r[f];
  return o;
}, ln = function(t, r) {
  for (var o = [], a = r, f = 0; a < t.length; a += 1, f += 1)
    o[f] = t[a];
  return o;
}, sn = function(e, t) {
  for (var r = "", o = 0; o < e.length; o += 1)
    r += e[o], o + 1 < e.length && (r += t);
  return r;
}, cn = function(t) {
  var r = this;
  if (typeof r != "function" || an.apply(r) !== un)
    throw new TypeError(on + r);
  for (var o = ln(arguments, 1), a, f = function() {
    if (this instanceof a) {
      var _ = r.apply(
        this,
        Wt(o, arguments)
      );
      return Object(_) === _ ? _ : this;
    }
    return r.apply(
      t,
      Wt(o, arguments)
    );
  }, c = fn(0, r.length - o.length), d = [], s = 0; s < c; s++)
    d[s] = "$" + s;
  if (a = Function("binder", "return function (" + sn(d, ",") + "){ return binder.apply(this,arguments); }")(f), r.prototype) {
    var v = function() {
    };
    v.prototype = r.prototype, a.prototype = new v(), v.prototype = null;
  }
  return a;
}, dn = cn, Tt = Function.prototype.bind || dn, pn = Function.prototype.call, yn = Object.prototype.hasOwnProperty, hn = Tt, gn = hn.call(pn, yn), W, vn = Jr, bn = Yr, mn = Zr, wn = Xr, me = Er, be = Ue, _n = Qr, Ar = Function, He = function(e) {
  try {
    return Ar('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, ue = Object.getOwnPropertyDescriptor;
if (ue)
  try {
    ue({}, "");
  } catch {
    ue = null;
  }
var Ve = function() {
  throw new be();
}, Sn = ue ? function() {
  try {
    return arguments.callee, Ve;
  } catch {
    try {
      return ue(arguments, "callee").get;
    } catch {
      return Ve;
    }
  }
}() : Ve, pe = tn(), En = nn(), V = Object.getPrototypeOf || (En ? function(e) {
  return e.__proto__;
} : null), he = {}, An = typeof Uint8Array > "u" || !V ? W : V(Uint8Array), le = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? W : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? W : ArrayBuffer,
  "%ArrayIteratorPrototype%": pe && V ? V([][Symbol.iterator]()) : W,
  "%AsyncFromSyncIteratorPrototype%": W,
  "%AsyncFunction%": he,
  "%AsyncGenerator%": he,
  "%AsyncGeneratorFunction%": he,
  "%AsyncIteratorPrototype%": he,
  "%Atomics%": typeof Atomics > "u" ? W : Atomics,
  "%BigInt%": typeof BigInt > "u" ? W : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? W : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? W : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? W : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": vn,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": bn,
  "%Float32Array%": typeof Float32Array > "u" ? W : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? W : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? W : FinalizationRegistry,
  "%Function%": Ar,
  "%GeneratorFunction%": he,
  "%Int8Array%": typeof Int8Array > "u" ? W : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? W : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? W : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": pe && V ? V(V([][Symbol.iterator]())) : W,
  "%JSON%": typeof JSON == "object" ? JSON : W,
  "%Map%": typeof Map > "u" ? W : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !pe || !V ? W : V((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? W : Promise,
  "%Proxy%": typeof Proxy > "u" ? W : Proxy,
  "%RangeError%": mn,
  "%ReferenceError%": wn,
  "%Reflect%": typeof Reflect > "u" ? W : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? W : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !pe || !V ? W : V((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? W : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": pe && V ? V(""[Symbol.iterator]()) : W,
  "%Symbol%": pe ? Symbol : W,
  "%SyntaxError%": me,
  "%ThrowTypeError%": Sn,
  "%TypedArray%": An,
  "%TypeError%": be,
  "%Uint8Array%": typeof Uint8Array > "u" ? W : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? W : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? W : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? W : Uint32Array,
  "%URIError%": _n,
  "%WeakMap%": typeof WeakMap > "u" ? W : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? W : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? W : WeakSet
};
if (V)
  try {
    null.error;
  } catch (e) {
    var Rn = V(V(e));
    le["%Error.prototype%"] = Rn;
  }
var On = function e(t) {
  var r;
  if (t === "%AsyncFunction%")
    r = He("async function () {}");
  else if (t === "%GeneratorFunction%")
    r = He("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    r = He("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var o = e("%AsyncGeneratorFunction%");
    o && (r = o.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var a = e("%AsyncGenerator%");
    a && V && (r = V(a.prototype));
  }
  return le[t] = r, r;
}, qt = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Ee = Tt, Ne = gn, Tn = Ee.call(Function.call, Array.prototype.concat), Pn = Ee.call(Function.apply, Array.prototype.splice), xt = Ee.call(Function.call, String.prototype.replace), Ie = Ee.call(Function.call, String.prototype.slice), jn = Ee.call(Function.call, RegExp.prototype.exec), Mn = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Ln = /\\(\\)?/g, Nn = function(t) {
  var r = Ie(t, 0, 1), o = Ie(t, -1);
  if (r === "%" && o !== "%")
    throw new me("invalid intrinsic syntax, expected closing `%`");
  if (o === "%" && r !== "%")
    throw new me("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return xt(t, Mn, function(f, c, d, s) {
    a[a.length] = d ? xt(s, Ln, "$1") : c || f;
  }), a;
}, In = function(t, r) {
  var o = t, a;
  if (Ne(qt, o) && (a = qt[o], o = "%" + a[0] + "%"), Ne(le, o)) {
    var f = le[o];
    if (f === he && (f = On(o)), typeof f > "u" && !r)
      throw new be("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: o,
      value: f
    };
  }
  throw new me("intrinsic " + t + " does not exist!");
}, Ae = function(t, r) {
  if (typeof t != "string" || t.length === 0)
    throw new be("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new be('"allowMissing" argument must be a boolean');
  if (jn(/^%?[^%]*%?$/, t) === null)
    throw new me("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var o = Nn(t), a = o.length > 0 ? o[0] : "", f = In("%" + a + "%", r), c = f.name, d = f.value, s = !1, v = f.alias;
  v && (a = v[0], Pn(o, Tn([0, 1], v)));
  for (var _ = 1, R = !0; _ < o.length; _ += 1) {
    var m = o[_], I = Ie(m, 0, 1), S = Ie(m, -1);
    if ((I === '"' || I === "'" || I === "`" || S === '"' || S === "'" || S === "`") && I !== S)
      throw new me("property names with quotes must have matching quotes");
    if ((m === "constructor" || !R) && (s = !0), a += "." + m, c = "%" + a + "%", Ne(le, c))
      d = le[c];
    else if (d != null) {
      if (!(m in d)) {
        if (!r)
          throw new be("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (ue && _ + 1 >= o.length) {
        var P = ue(d, m);
        R = !!P, R && "get" in P && !("originalValue" in P.get) ? d = P.get : d = d[m];
      } else
        R = Ne(d, m), d = d[m];
      R && !s && (le[c] = d);
    }
  }
  return d;
}, Rr = { exports: {} }, ze, Gt;
function Pt() {
  if (Gt) return ze;
  Gt = 1;
  var e = Ae, t = e("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return ze = t, ze;
}
var Dn = Ae, Pe = Dn("%Object.getOwnPropertyDescriptor%", !0);
if (Pe)
  try {
    Pe([], "length");
  } catch {
    Pe = null;
  }
var jt = Pe, Ht = Pt(), Bn = Er, ye = Ue, Vt = jt, Cn = function(t, r, o) {
  if (!t || typeof t != "object" && typeof t != "function")
    throw new ye("`obj` must be an object or a function`");
  if (typeof r != "string" && typeof r != "symbol")
    throw new ye("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new ye("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new ye("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new ye("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new ye("`loose`, if provided, must be a boolean");
  var a = arguments.length > 3 ? arguments[3] : null, f = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 ? arguments[6] : !1, s = !!Vt && Vt(t, r);
  if (Ht)
    Ht(t, r, {
      configurable: c === null && s ? s.configurable : !c,
      enumerable: a === null && s ? s.enumerable : !a,
      value: o,
      writable: f === null && s ? s.writable : !f
    });
  else if (d || !a && !f && !c)
    t[r] = o;
  else
    throw new Bn("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, ht = Pt(), Or = function() {
  return !!ht;
};
Or.hasArrayLengthDefineBug = function() {
  if (!ht)
    return null;
  try {
    return ht([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var Fn = Or, Un = Ae, zt = Cn, kn = Fn(), Kt = jt, Jt = Ue, $n = Un("%Math.floor%"), Wn = function(t, r) {
  if (typeof t != "function")
    throw new Jt("`fn` is not a function");
  if (typeof r != "number" || r < 0 || r > 4294967295 || $n(r) !== r)
    throw new Jt("`length` must be a positive 32-bit integer");
  var o = arguments.length > 2 && !!arguments[2], a = !0, f = !0;
  if ("length" in t && Kt) {
    var c = Kt(t, "length");
    c && !c.configurable && (a = !1), c && !c.writable && (f = !1);
  }
  return (a || f || !o) && (kn ? zt(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    r,
    !0,
    !0
  ) : zt(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    r
  )), t;
};
(function(e) {
  var t = Tt, r = Ae, o = Wn, a = Ue, f = r("%Function.prototype.apply%"), c = r("%Function.prototype.call%"), d = r("%Reflect.apply%", !0) || t.call(c, f), s = Pt(), v = r("%Math.max%");
  e.exports = function(m) {
    if (typeof m != "function")
      throw new a("a function is required");
    var I = d(t, c, arguments);
    return o(
      I,
      1 + v(0, m.length - (arguments.length - 1)),
      !0
    );
  };
  var _ = function() {
    return d(t, f, arguments);
  };
  s ? s(e.exports, "apply", { value: _ }) : e.exports.apply = _;
})(Rr);
var Tr = Rr.exports, Pr = Ae, jr = Tr, qn = jr(Pr("String.prototype.indexOf")), Mr = function(t, r) {
  var o = Pr(t, !!r);
  return typeof o == "function" && qn(t, ".prototype.") > -1 ? jr(o) : o;
}, xn = Ot(), Gn = Mr, gt = Gn("Object.prototype.toString"), ke = function(t) {
  return xn && t && typeof t == "object" && Symbol.toStringTag in t ? !1 : gt(t) === "[object Arguments]";
}, Lr = function(t) {
  return ke(t) ? !0 : t !== null && typeof t == "object" && typeof t.length == "number" && t.length >= 0 && gt(t) !== "[object Array]" && gt(t.callee) === "[object Function]";
}, Hn = function() {
  return ke(arguments);
}();
ke.isLegacyArguments = Lr;
var Vn = Hn ? ke : Lr, zn = Object.prototype.toString, Kn = Function.prototype.toString, Jn = /^\s*(?:function)?\*/, Nr = Ot(), Ke = Object.getPrototypeOf, Yn = function() {
  if (!Nr)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, Je, Zn = function(t) {
  if (typeof t != "function")
    return !1;
  if (Jn.test(Kn.call(t)))
    return !0;
  if (!Nr) {
    var r = zn.call(t);
    return r === "[object GeneratorFunction]";
  }
  if (!Ke)
    return !1;
  if (typeof Je > "u") {
    var o = Yn();
    Je = o ? Ke(o) : !1;
  }
  return Ke(t) === Je;
}, Ir = Function.prototype.toString, ge = typeof Reflect == "object" && Reflect !== null && Reflect.apply, vt, je;
if (typeof ge == "function" && typeof Object.defineProperty == "function")
  try {
    vt = Object.defineProperty({}, "length", {
      get: function() {
        throw je;
      }
    }), je = {}, ge(function() {
      throw 42;
    }, null, vt);
  } catch (e) {
    e !== je && (ge = null);
  }
else
  ge = null;
var Xn = /^\s*class\b/, bt = function(t) {
  try {
    var r = Ir.call(t);
    return Xn.test(r);
  } catch {
    return !1;
  }
}, Ye = function(t) {
  try {
    return bt(t) ? !1 : (Ir.call(t), !0);
  } catch {
    return !1;
  }
}, Me = Object.prototype.toString, Qn = "[object Object]", ei = "[object Function]", ti = "[object GeneratorFunction]", ri = "[object HTMLAllCollection]", ni = "[object HTML document.all class]", ii = "[object HTMLCollection]", oi = typeof Symbol == "function" && !!Symbol.toStringTag, ai = !(0 in [,]), mt = function() {
  return !1;
};
if (typeof document == "object") {
  var fi = document.all;
  Me.call(fi) === Me.call(document.all) && (mt = function(t) {
    if ((ai || !t) && (typeof t > "u" || typeof t == "object"))
      try {
        var r = Me.call(t);
        return (r === ri || r === ni || r === ii || r === Qn) && t("") == null;
      } catch {
      }
    return !1;
  });
}
var ui = ge ? function(t) {
  if (mt(t))
    return !0;
  if (!t || typeof t != "function" && typeof t != "object")
    return !1;
  try {
    ge(t, null, vt);
  } catch (r) {
    if (r !== je)
      return !1;
  }
  return !bt(t) && Ye(t);
} : function(t) {
  if (mt(t))
    return !0;
  if (!t || typeof t != "function" && typeof t != "object")
    return !1;
  if (oi)
    return Ye(t);
  if (bt(t))
    return !1;
  var r = Me.call(t);
  return r !== ei && r !== ti && !/^\[object HTML/.test(r) ? !1 : Ye(t);
}, li = ui, si = Object.prototype.toString, Dr = Object.prototype.hasOwnProperty, ci = function(t, r, o) {
  for (var a = 0, f = t.length; a < f; a++)
    Dr.call(t, a) && (o == null ? r(t[a], a, t) : r.call(o, t[a], a, t));
}, di = function(t, r, o) {
  for (var a = 0, f = t.length; a < f; a++)
    o == null ? r(t.charAt(a), a, t) : r.call(o, t.charAt(a), a, t);
}, pi = function(t, r, o) {
  for (var a in t)
    Dr.call(t, a) && (o == null ? r(t[a], a, t) : r.call(o, t[a], a, t));
}, yi = function(t, r, o) {
  if (!li(r))
    throw new TypeError("iterator must be a function");
  var a;
  arguments.length >= 3 && (a = o), si.call(t) === "[object Array]" ? ci(t, r, a) : typeof t == "string" ? di(t, r, a) : pi(t, r, a);
}, hi = yi, gi = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], Ze = gi, vi = typeof globalThis > "u" ? fe : globalThis, bi = function() {
  for (var t = [], r = 0; r < Ze.length; r++)
    typeof vi[Ze[r]] == "function" && (t[t.length] = Ze[r]);
  return t;
}, De = hi, mi = bi, Yt = Tr, Mt = Mr, Le = jt, wi = Mt("Object.prototype.toString"), Br = Ot(), Zt = typeof globalThis > "u" ? fe : globalThis, wt = mi(), Lt = Mt("String.prototype.slice"), Xe = Object.getPrototypeOf, _i = Mt("Array.prototype.indexOf", !0) || function(t, r) {
  for (var o = 0; o < t.length; o += 1)
    if (t[o] === r)
      return o;
  return -1;
}, Be = { __proto__: null };
Br && Le && Xe ? De(wt, function(e) {
  var t = new Zt[e]();
  if (Symbol.toStringTag in t) {
    var r = Xe(t), o = Le(r, Symbol.toStringTag);
    if (!o) {
      var a = Xe(r);
      o = Le(a, Symbol.toStringTag);
    }
    Be["$" + e] = Yt(o.get);
  }
}) : De(wt, function(e) {
  var t = new Zt[e](), r = t.slice || t.set;
  r && (Be["$" + e] = Yt(r));
});
var Si = function(t) {
  var r = !1;
  return De(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    Be,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(o, a) {
      if (!r)
        try {
          "$" + o(t) === a && (r = Lt(a, 1));
        } catch {
        }
    }
  ), r;
}, Ei = function(t) {
  var r = !1;
  return De(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    Be,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(o, a) {
      if (!r)
        try {
          o(t), r = Lt(a, 1);
        } catch {
        }
    }
  ), r;
}, Cr = function(t) {
  if (!t || typeof t != "object")
    return !1;
  if (!Br) {
    var r = Lt(wi(t), 8, -1);
    return _i(wt, r) > -1 ? r : r !== "Object" ? !1 : Ei(t);
  }
  return Le ? Si(t) : null;
}, Ai = Cr, Ri = function(t) {
  return !!Ai(t);
};
(function(e) {
  var t = Vn, r = Zn, o = Cr, a = Ri;
  function f(g) {
    return g.call.bind(g);
  }
  var c = typeof BigInt < "u", d = typeof Symbol < "u", s = f(Object.prototype.toString), v = f(Number.prototype.valueOf), _ = f(String.prototype.valueOf), R = f(Boolean.prototype.valueOf);
  if (c)
    var m = f(BigInt.prototype.valueOf);
  if (d)
    var I = f(Symbol.prototype.valueOf);
  function S(g, Oe) {
    if (typeof g != "object")
      return !1;
    try {
      return Oe(g), !0;
    } catch {
      return !1;
    }
  }
  e.isArgumentsObject = t, e.isGeneratorFunction = r, e.isTypedArray = a;
  function P(g) {
    return typeof Promise < "u" && g instanceof Promise || g !== null && typeof g == "object" && typeof g.then == "function" && typeof g.catch == "function";
  }
  e.isPromise = P;
  function E(g) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(g) : a(g) || h(g);
  }
  e.isArrayBufferView = E;
  function O(g) {
    return o(g) === "Uint8Array";
  }
  e.isUint8Array = O;
  function L(g) {
    return o(g) === "Uint8ClampedArray";
  }
  e.isUint8ClampedArray = L;
  function N(g) {
    return o(g) === "Uint16Array";
  }
  e.isUint16Array = N;
  function j(g) {
    return o(g) === "Uint32Array";
  }
  e.isUint32Array = j;
  function D(g) {
    return o(g) === "Int8Array";
  }
  e.isInt8Array = D;
  function C(g) {
    return o(g) === "Int16Array";
  }
  e.isInt16Array = C;
  function q(g) {
    return o(g) === "Int32Array";
  }
  e.isInt32Array = q;
  function U(g) {
    return o(g) === "Float32Array";
  }
  e.isFloat32Array = U;
  function B(g) {
    return o(g) === "Float64Array";
  }
  e.isFloat64Array = B;
  function z(g) {
    return o(g) === "BigInt64Array";
  }
  e.isBigInt64Array = z;
  function J(g) {
    return o(g) === "BigUint64Array";
  }
  e.isBigUint64Array = J;
  function Y(g) {
    return s(g) === "[object Map]";
  }
  Y.working = typeof Map < "u" && Y(/* @__PURE__ */ new Map());
  function re(g) {
    return typeof Map > "u" ? !1 : Y.working ? Y(g) : g instanceof Map;
  }
  e.isMap = re;
  function Z(g) {
    return s(g) === "[object Set]";
  }
  Z.working = typeof Set < "u" && Z(/* @__PURE__ */ new Set());
  function ne(g) {
    return typeof Set > "u" ? !1 : Z.working ? Z(g) : g instanceof Set;
  }
  e.isSet = ne;
  function ie(g) {
    return s(g) === "[object WeakMap]";
  }
  ie.working = typeof WeakMap < "u" && ie(/* @__PURE__ */ new WeakMap());
  function Q(g) {
    return typeof WeakMap > "u" ? !1 : ie.working ? ie(g) : g instanceof WeakMap;
  }
  e.isWeakMap = Q;
  function ee(g) {
    return s(g) === "[object WeakSet]";
  }
  ee.working = typeof WeakSet < "u" && ee(/* @__PURE__ */ new WeakSet());
  function K(g) {
    return ee(g);
  }
  e.isWeakSet = K;
  function te(g) {
    return s(g) === "[object ArrayBuffer]";
  }
  te.working = typeof ArrayBuffer < "u" && te(new ArrayBuffer());
  function oe(g) {
    return typeof ArrayBuffer > "u" ? !1 : te.working ? te(g) : g instanceof ArrayBuffer;
  }
  e.isArrayBuffer = oe;
  function p(g) {
    return s(g) === "[object DataView]";
  }
  p.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && p(new DataView(new ArrayBuffer(1), 0, 1));
  function h(g) {
    return typeof DataView > "u" ? !1 : p.working ? p(g) : g instanceof DataView;
  }
  e.isDataView = h;
  var w = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function F(g) {
    return s(g) === "[object SharedArrayBuffer]";
  }
  function l(g) {
    return typeof w > "u" ? !1 : (typeof F.working > "u" && (F.working = F(new w())), F.working ? F(g) : g instanceof w);
  }
  e.isSharedArrayBuffer = l;
  function u(g) {
    return s(g) === "[object AsyncFunction]";
  }
  e.isAsyncFunction = u;
  function y(g) {
    return s(g) === "[object Map Iterator]";
  }
  e.isMapIterator = y;
  function A(g) {
    return s(g) === "[object Set Iterator]";
  }
  e.isSetIterator = A;
  function M(g) {
    return s(g) === "[object Generator]";
  }
  e.isGeneratorObject = M;
  function n(g) {
    return s(g) === "[object WebAssembly.Module]";
  }
  e.isWebAssemblyCompiledModule = n;
  function i(g) {
    return S(g, v);
  }
  e.isNumberObject = i;
  function b(g) {
    return S(g, _);
  }
  e.isStringObject = b;
  function T(g) {
    return S(g, R);
  }
  e.isBooleanObject = T;
  function H(g) {
    return c && S(g, m);
  }
  e.isBigIntObject = H;
  function k(g) {
    return d && S(g, I);
  }
  e.isSymbolObject = k;
  function x(g) {
    return i(g) || b(g) || T(g) || H(g) || k(g);
  }
  e.isBoxedPrimitive = x;
  function ae(g) {
    return typeof Uint8Array < "u" && (oe(g) || l(g));
  }
  e.isAnyArrayBuffer = ae, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(g) {
    Object.defineProperty(e, g, {
      enumerable: !1,
      value: function() {
        throw new Error(g + " is not supported in userland");
      }
    });
  });
})(_r);
var Oi = function(t) {
  return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
};
(function(e) {
  var t = Object.getOwnPropertyDescriptors || function(h) {
    for (var w = Object.keys(h), F = {}, l = 0; l < w.length; l++)
      F[w[l]] = Object.getOwnPropertyDescriptor(h, w[l]);
    return F;
  }, r = /%[sdj%]/g;
  e.format = function(p) {
    if (!D(p)) {
      for (var h = [], w = 0; w < arguments.length; w++)
        h.push(c(arguments[w]));
      return h.join(" ");
    }
    for (var w = 1, F = arguments, l = F.length, u = String(p).replace(r, function(A) {
      if (A === "%%") return "%";
      if (w >= l) return A;
      switch (A) {
        case "%s":
          return String(F[w++]);
        case "%d":
          return Number(F[w++]);
        case "%j":
          try {
            return JSON.stringify(F[w++]);
          } catch {
            return "[Circular]";
          }
        default:
          return A;
      }
    }), y = F[w]; w < l; y = F[++w])
      L(y) || !B(y) ? u += " " + y : u += " " + c(y);
    return u;
  }, e.deprecate = function(p, h) {
    if (typeof $ < "u" && $.noDeprecation === !0)
      return p;
    if (typeof $ > "u")
      return function() {
        return e.deprecate(p, h).apply(this, arguments);
      };
    var w = !1;
    function F() {
      if (!w) {
        if ($.throwDeprecation)
          throw new Error(h);
        $.traceDeprecation ? console.trace(h) : console.error(h), w = !0;
      }
      return p.apply(this, arguments);
    }
    return F;
  };
  var o = {}, a = /^$/;
  if ($.env.NODE_DEBUG) {
    var f = $.env.NODE_DEBUG;
    f = f.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), a = new RegExp("^" + f + "$", "i");
  }
  e.debuglog = function(p) {
    if (p = p.toUpperCase(), !o[p])
      if (a.test(p)) {
        var h = $.pid;
        o[p] = function() {
          var w = e.format.apply(e, arguments);
          console.error("%s %d: %s", p, h, w);
        };
      } else
        o[p] = function() {
        };
    return o[p];
  };
  function c(p, h) {
    var w = {
      seen: [],
      stylize: s
    };
    return arguments.length >= 3 && (w.depth = arguments[2]), arguments.length >= 4 && (w.colors = arguments[3]), O(h) ? w.showHidden = h : h && e._extend(w, h), q(w.showHidden) && (w.showHidden = !1), q(w.depth) && (w.depth = 2), q(w.colors) && (w.colors = !1), q(w.customInspect) && (w.customInspect = !0), w.colors && (w.stylize = d), _(w, p, w.depth);
  }
  e.inspect = c, c.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, c.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function d(p, h) {
    var w = c.styles[h];
    return w ? "\x1B[" + c.colors[w][0] + "m" + p + "\x1B[" + c.colors[w][1] + "m" : p;
  }
  function s(p, h) {
    return p;
  }
  function v(p) {
    var h = {};
    return p.forEach(function(w, F) {
      h[w] = !0;
    }), h;
  }
  function _(p, h, w) {
    if (p.customInspect && h && Y(h.inspect) && // Filter out the util module, it's inspect function is special
    h.inspect !== e.inspect && // Also filter out any prototype objects using the circular check.
    !(h.constructor && h.constructor.prototype === h)) {
      var F = h.inspect(w, p);
      return D(F) || (F = _(p, F, w)), F;
    }
    var l = R(p, h);
    if (l)
      return l;
    var u = Object.keys(h), y = v(u);
    if (p.showHidden && (u = Object.getOwnPropertyNames(h)), J(h) && (u.indexOf("message") >= 0 || u.indexOf("description") >= 0))
      return m(h);
    if (u.length === 0) {
      if (Y(h)) {
        var A = h.name ? ": " + h.name : "";
        return p.stylize("[Function" + A + "]", "special");
      }
      if (U(h))
        return p.stylize(RegExp.prototype.toString.call(h), "regexp");
      if (z(h))
        return p.stylize(Date.prototype.toString.call(h), "date");
      if (J(h))
        return m(h);
    }
    var M = "", n = !1, i = ["{", "}"];
    if (E(h) && (n = !0, i = ["[", "]"]), Y(h)) {
      var b = h.name ? ": " + h.name : "";
      M = " [Function" + b + "]";
    }
    if (U(h) && (M = " " + RegExp.prototype.toString.call(h)), z(h) && (M = " " + Date.prototype.toUTCString.call(h)), J(h) && (M = " " + m(h)), u.length === 0 && (!n || h.length == 0))
      return i[0] + M + i[1];
    if (w < 0)
      return U(h) ? p.stylize(RegExp.prototype.toString.call(h), "regexp") : p.stylize("[Object]", "special");
    p.seen.push(h);
    var T;
    return n ? T = I(p, h, w, y, u) : T = u.map(function(H) {
      return S(p, h, w, y, H, n);
    }), p.seen.pop(), P(T, M, i);
  }
  function R(p, h) {
    if (q(h))
      return p.stylize("undefined", "undefined");
    if (D(h)) {
      var w = "'" + JSON.stringify(h).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return p.stylize(w, "string");
    }
    if (j(h))
      return p.stylize("" + h, "number");
    if (O(h))
      return p.stylize("" + h, "boolean");
    if (L(h))
      return p.stylize("null", "null");
  }
  function m(p) {
    return "[" + Error.prototype.toString.call(p) + "]";
  }
  function I(p, h, w, F, l) {
    for (var u = [], y = 0, A = h.length; y < A; ++y)
      ee(h, String(y)) ? u.push(S(
        p,
        h,
        w,
        F,
        String(y),
        !0
      )) : u.push("");
    return l.forEach(function(M) {
      M.match(/^\d+$/) || u.push(S(
        p,
        h,
        w,
        F,
        M,
        !0
      ));
    }), u;
  }
  function S(p, h, w, F, l, u) {
    var y, A, M;
    if (M = Object.getOwnPropertyDescriptor(h, l) || { value: h[l] }, M.get ? M.set ? A = p.stylize("[Getter/Setter]", "special") : A = p.stylize("[Getter]", "special") : M.set && (A = p.stylize("[Setter]", "special")), ee(F, l) || (y = "[" + l + "]"), A || (p.seen.indexOf(M.value) < 0 ? (L(w) ? A = _(p, M.value, null) : A = _(p, M.value, w - 1), A.indexOf(`
`) > -1 && (u ? A = A.split(`
`).map(function(n) {
      return "  " + n;
    }).join(`
`).slice(2) : A = `
` + A.split(`
`).map(function(n) {
      return "   " + n;
    }).join(`
`))) : A = p.stylize("[Circular]", "special")), q(y)) {
      if (u && l.match(/^\d+$/))
        return A;
      y = JSON.stringify("" + l), y.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (y = y.slice(1, -1), y = p.stylize(y, "name")) : (y = y.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), y = p.stylize(y, "string"));
    }
    return y + ": " + A;
  }
  function P(p, h, w) {
    var F = p.reduce(function(l, u) {
      return u.indexOf(`
`) >= 0, l + u.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return F > 60 ? w[0] + (h === "" ? "" : h + `
 `) + " " + p.join(`,
  `) + " " + w[1] : w[0] + h + " " + p.join(", ") + " " + w[1];
  }
  e.types = _r;
  function E(p) {
    return Array.isArray(p);
  }
  e.isArray = E;
  function O(p) {
    return typeof p == "boolean";
  }
  e.isBoolean = O;
  function L(p) {
    return p === null;
  }
  e.isNull = L;
  function N(p) {
    return p == null;
  }
  e.isNullOrUndefined = N;
  function j(p) {
    return typeof p == "number";
  }
  e.isNumber = j;
  function D(p) {
    return typeof p == "string";
  }
  e.isString = D;
  function C(p) {
    return typeof p == "symbol";
  }
  e.isSymbol = C;
  function q(p) {
    return p === void 0;
  }
  e.isUndefined = q;
  function U(p) {
    return B(p) && Z(p) === "[object RegExp]";
  }
  e.isRegExp = U, e.types.isRegExp = U;
  function B(p) {
    return typeof p == "object" && p !== null;
  }
  e.isObject = B;
  function z(p) {
    return B(p) && Z(p) === "[object Date]";
  }
  e.isDate = z, e.types.isDate = z;
  function J(p) {
    return B(p) && (Z(p) === "[object Error]" || p instanceof Error);
  }
  e.isError = J, e.types.isNativeError = J;
  function Y(p) {
    return typeof p == "function";
  }
  e.isFunction = Y;
  function re(p) {
    return p === null || typeof p == "boolean" || typeof p == "number" || typeof p == "string" || typeof p == "symbol" || // ES6 symbol
    typeof p > "u";
  }
  e.isPrimitive = re, e.isBuffer = Oi;
  function Z(p) {
    return Object.prototype.toString.call(p);
  }
  function ne(p) {
    return p < 10 ? "0" + p.toString(10) : p.toString(10);
  }
  var ie = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function Q() {
    var p = /* @__PURE__ */ new Date(), h = [
      ne(p.getHours()),
      ne(p.getMinutes()),
      ne(p.getSeconds())
    ].join(":");
    return [p.getDate(), ie[p.getMonth()], h].join(" ");
  }
  e.log = function() {
    console.log("%s - %s", Q(), e.format.apply(e, arguments));
  }, e.inherits = se, e._extend = function(p, h) {
    if (!h || !B(h)) return p;
    for (var w = Object.keys(h), F = w.length; F--; )
      p[w[F]] = h[w[F]];
    return p;
  };
  function ee(p, h) {
    return Object.prototype.hasOwnProperty.call(p, h);
  }
  var K = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  e.promisify = function(h) {
    if (typeof h != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (K && h[K]) {
      var w = h[K];
      if (typeof w != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(w, K, {
        value: w,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), w;
    }
    function w() {
      for (var F, l, u = new Promise(function(M, n) {
        F = M, l = n;
      }), y = [], A = 0; A < arguments.length; A++)
        y.push(arguments[A]);
      y.push(function(M, n) {
        M ? l(M) : F(n);
      });
      try {
        h.apply(this, y);
      } catch (M) {
        l(M);
      }
      return u;
    }
    return Object.setPrototypeOf(w, Object.getPrototypeOf(h)), K && Object.defineProperty(w, K, {
      value: w,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      w,
      t(h)
    );
  }, e.promisify.custom = K;
  function te(p, h) {
    if (!p) {
      var w = new Error("Promise was rejected with a falsy value");
      w.reason = p, p = w;
    }
    return h(p);
  }
  function oe(p) {
    if (typeof p != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function h() {
      for (var w = [], F = 0; F < arguments.length; F++)
        w.push(arguments[F]);
      var l = w.pop();
      if (typeof l != "function")
        throw new TypeError("The last argument must be of type Function");
      var u = this, y = function() {
        return l.apply(u, arguments);
      };
      p.apply(this, w).then(
        function(A) {
          $.nextTick(y.bind(null, null, A));
        },
        function(A) {
          $.nextTick(te.bind(null, A, y));
        }
      );
    }
    return Object.setPrototypeOf(h, Object.getPrototypeOf(p)), Object.defineProperties(
      h,
      t(p)
    ), h;
  }
  e.callbackify = oe;
})(Rt);
var Qe, Xt;
function Ti() {
  if (Xt) return Qe;
  Xt = 1;
  function e(S, P) {
    var E = Object.keys(S);
    if (Object.getOwnPropertySymbols) {
      var O = Object.getOwnPropertySymbols(S);
      P && (O = O.filter(function(L) {
        return Object.getOwnPropertyDescriptor(S, L).enumerable;
      })), E.push.apply(E, O);
    }
    return E;
  }
  function t(S) {
    for (var P = 1; P < arguments.length; P++) {
      var E = arguments[P] != null ? arguments[P] : {};
      P % 2 ? e(Object(E), !0).forEach(function(O) {
        r(S, O, E[O]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(S, Object.getOwnPropertyDescriptors(E)) : e(Object(E)).forEach(function(O) {
        Object.defineProperty(S, O, Object.getOwnPropertyDescriptor(E, O));
      });
    }
    return S;
  }
  function r(S, P, E) {
    return P = c(P), P in S ? Object.defineProperty(S, P, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : S[P] = E, S;
  }
  function o(S, P) {
    if (!(S instanceof P))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(S, P) {
    for (var E = 0; E < P.length; E++) {
      var O = P[E];
      O.enumerable = O.enumerable || !1, O.configurable = !0, "value" in O && (O.writable = !0), Object.defineProperty(S, c(O.key), O);
    }
  }
  function f(S, P, E) {
    return P && a(S.prototype, P), Object.defineProperty(S, "prototype", { writable: !1 }), S;
  }
  function c(S) {
    var P = d(S, "string");
    return typeof P == "symbol" ? P : String(P);
  }
  function d(S, P) {
    if (typeof S != "object" || S === null) return S;
    var E = S[Symbol.toPrimitive];
    if (E !== void 0) {
      var O = E.call(S, P || "default");
      if (typeof O != "object") return O;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (P === "string" ? String : Number)(S);
  }
  var s = Ce, v = s.Buffer, _ = Rt, R = _.inspect, m = R && R.custom || "inspect";
  function I(S, P, E) {
    v.prototype.copy.call(S, P, E);
  }
  return Qe = /* @__PURE__ */ function() {
    function S() {
      o(this, S), this.head = null, this.tail = null, this.length = 0;
    }
    return f(S, [{
      key: "push",
      value: function(E) {
        var O = {
          data: E,
          next: null
        };
        this.length > 0 ? this.tail.next = O : this.head = O, this.tail = O, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(E) {
        var O = {
          data: E,
          next: this.head
        };
        this.length === 0 && (this.tail = O), this.head = O, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var E = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, E;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(E) {
        if (this.length === 0) return "";
        for (var O = this.head, L = "" + O.data; O = O.next; ) L += E + O.data;
        return L;
      }
    }, {
      key: "concat",
      value: function(E) {
        if (this.length === 0) return v.alloc(0);
        for (var O = v.allocUnsafe(E >>> 0), L = this.head, N = 0; L; )
          I(L.data, O, N), N += L.data.length, L = L.next;
        return O;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(E, O) {
        var L;
        return E < this.head.data.length ? (L = this.head.data.slice(0, E), this.head.data = this.head.data.slice(E)) : E === this.head.data.length ? L = this.shift() : L = O ? this._getString(E) : this._getBuffer(E), L;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(E) {
        var O = this.head, L = 1, N = O.data;
        for (E -= N.length; O = O.next; ) {
          var j = O.data, D = E > j.length ? j.length : E;
          if (D === j.length ? N += j : N += j.slice(0, E), E -= D, E === 0) {
            D === j.length ? (++L, O.next ? this.head = O.next : this.head = this.tail = null) : (this.head = O, O.data = j.slice(D));
            break;
          }
          ++L;
        }
        return this.length -= L, N;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(E) {
        var O = v.allocUnsafe(E), L = this.head, N = 1;
        for (L.data.copy(O), E -= L.data.length; L = L.next; ) {
          var j = L.data, D = E > j.length ? j.length : E;
          if (j.copy(O, O.length - E, 0, D), E -= D, E === 0) {
            D === j.length ? (++N, L.next ? this.head = L.next : this.head = this.tail = null) : (this.head = L, L.data = j.slice(D));
            break;
          }
          ++N;
        }
        return this.length -= N, O;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: m,
      value: function(E, O) {
        return R(this, t(t({}, O), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), S;
  }(), Qe;
}
var et, Qt;
function Fr() {
  if (Qt) return et;
  Qt = 1;
  function e(c, d) {
    var s = this, v = this._readableState && this._readableState.destroyed, _ = this._writableState && this._writableState.destroyed;
    return v || _ ? (d ? d(c) : c && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, $.nextTick(a, this, c)) : $.nextTick(a, this, c)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(c || null, function(R) {
      !d && R ? s._writableState ? s._writableState.errorEmitted ? $.nextTick(r, s) : (s._writableState.errorEmitted = !0, $.nextTick(t, s, R)) : $.nextTick(t, s, R) : d ? ($.nextTick(r, s), d(R)) : $.nextTick(r, s);
    }), this);
  }
  function t(c, d) {
    a(c, d), r(c);
  }
  function r(c) {
    c._writableState && !c._writableState.emitClose || c._readableState && !c._readableState.emitClose || c.emit("close");
  }
  function o() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function a(c, d) {
    c.emit("error", d);
  }
  function f(c, d) {
    var s = c._readableState, v = c._writableState;
    s && s.autoDestroy || v && v.autoDestroy ? c.destroy(d) : c.emit("error", d);
  }
  return et = {
    destroy: e,
    undestroy: o,
    errorOrDestroy: f
  }, et;
}
var tt = {}, er;
function _e() {
  if (er) return tt;
  er = 1;
  function e(d, s) {
    d.prototype = Object.create(s.prototype), d.prototype.constructor = d, d.__proto__ = s;
  }
  var t = {};
  function r(d, s, v) {
    v || (v = Error);
    function _(m, I, S) {
      return typeof s == "string" ? s : s(m, I, S);
    }
    var R = /* @__PURE__ */ function(m) {
      e(I, m);
      function I(S, P, E) {
        return m.call(this, _(S, P, E)) || this;
      }
      return I;
    }(v);
    R.prototype.name = v.name, R.prototype.code = d, t[d] = R;
  }
  function o(d, s) {
    if (Array.isArray(d)) {
      var v = d.length;
      return d = d.map(function(_) {
        return String(_);
      }), v > 2 ? "one of ".concat(s, " ").concat(d.slice(0, v - 1).join(", "), ", or ") + d[v - 1] : v === 2 ? "one of ".concat(s, " ").concat(d[0], " or ").concat(d[1]) : "of ".concat(s, " ").concat(d[0]);
    } else
      return "of ".concat(s, " ").concat(String(d));
  }
  function a(d, s, v) {
    return d.substr(0, s.length) === s;
  }
  function f(d, s, v) {
    return (v === void 0 || v > d.length) && (v = d.length), d.substring(v - s.length, v) === s;
  }
  function c(d, s, v) {
    return typeof v != "number" && (v = 0), v + s.length > d.length ? !1 : d.indexOf(s, v) !== -1;
  }
  return r("ERR_INVALID_OPT_VALUE", function(d, s) {
    return 'The value "' + s + '" is invalid for option "' + d + '"';
  }, TypeError), r("ERR_INVALID_ARG_TYPE", function(d, s, v) {
    var _;
    typeof s == "string" && a(s, "not ") ? (_ = "must not be", s = s.replace(/^not /, "")) : _ = "must be";
    var R;
    if (f(d, " argument"))
      R = "The ".concat(d, " ").concat(_, " ").concat(o(s, "type"));
    else {
      var m = c(d, ".") ? "property" : "argument";
      R = 'The "'.concat(d, '" ').concat(m, " ").concat(_, " ").concat(o(s, "type"));
    }
    return R += ". Received type ".concat(typeof v), R;
  }, TypeError), r("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), r("ERR_METHOD_NOT_IMPLEMENTED", function(d) {
    return "The " + d + " method is not implemented";
  }), r("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), r("ERR_STREAM_DESTROYED", function(d) {
    return "Cannot call " + d + " after a stream was destroyed";
  }), r("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), r("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), r("ERR_STREAM_WRITE_AFTER_END", "write after end"), r("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), r("ERR_UNKNOWN_ENCODING", function(d) {
    return "Unknown encoding: " + d;
  }, TypeError), r("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), tt.codes = t, tt;
}
var rt, tr;
function Ur() {
  if (tr) return rt;
  tr = 1;
  var e = _e().codes.ERR_INVALID_OPT_VALUE;
  function t(o, a, f) {
    return o.highWaterMark != null ? o.highWaterMark : a ? o[f] : null;
  }
  function r(o, a, f, c) {
    var d = t(a, c, f);
    if (d != null) {
      if (!(isFinite(d) && Math.floor(d) === d) || d < 0) {
        var s = c ? f : "highWaterMark";
        throw new e(s, d);
      }
      return Math.floor(d);
    }
    return o.objectMode ? 16 : 16 * 1024;
  }
  return rt = {
    getHighWaterMark: r
  }, rt;
}
var Pi = ji;
function ji(e, t) {
  if (nt("noDeprecation"))
    return e;
  var r = !1;
  function o() {
    if (!r) {
      if (nt("throwDeprecation"))
        throw new Error(t);
      nt("traceDeprecation") ? console.trace(t) : console.warn(t), r = !0;
    }
    return e.apply(this, arguments);
  }
  return o;
}
function nt(e) {
  try {
    if (!fe.localStorage) return !1;
  } catch {
    return !1;
  }
  var t = fe.localStorage[e];
  return t == null ? !1 : String(t).toLowerCase() === "true";
}
var it, rr;
function kr() {
  if (rr) return it;
  rr = 1, it = U;
  function e(l) {
    var u = this;
    this.next = null, this.entry = null, this.finish = function() {
      F(u, l);
    };
  }
  var t;
  U.WritableState = C;
  var r = {
    deprecate: Pi
  }, o = wr(), a = Ce.Buffer, f = (typeof fe < "u" ? fe : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function c(l) {
    return a.from(l);
  }
  function d(l) {
    return a.isBuffer(l) || l instanceof f;
  }
  var s = Fr(), v = Ur(), _ = v.getHighWaterMark, R = _e().codes, m = R.ERR_INVALID_ARG_TYPE, I = R.ERR_METHOD_NOT_IMPLEMENTED, S = R.ERR_MULTIPLE_CALLBACK, P = R.ERR_STREAM_CANNOT_PIPE, E = R.ERR_STREAM_DESTROYED, O = R.ERR_STREAM_NULL_VALUES, L = R.ERR_STREAM_WRITE_AFTER_END, N = R.ERR_UNKNOWN_ENCODING, j = s.errorOrDestroy;
  se(U, o);
  function D() {
  }
  function C(l, u, y) {
    t = t || we(), l = l || {}, typeof y != "boolean" && (y = u instanceof t), this.objectMode = !!l.objectMode, y && (this.objectMode = this.objectMode || !!l.writableObjectMode), this.highWaterMark = _(this, l, "writableHighWaterMark", y), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var A = l.decodeStrings === !1;
    this.decodeStrings = !A, this.defaultEncoding = l.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(M) {
      ie(u, M);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = l.emitClose !== !1, this.autoDestroy = !!l.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  C.prototype.getBuffer = function() {
    for (var u = this.bufferedRequest, y = []; u; )
      y.push(u), u = u.next;
    return y;
  }, function() {
    try {
      Object.defineProperty(C.prototype, "buffer", {
        get: r.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var q;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (q = Function.prototype[Symbol.hasInstance], Object.defineProperty(U, Symbol.hasInstance, {
    value: function(u) {
      return q.call(this, u) ? !0 : this !== U ? !1 : u && u._writableState instanceof C;
    }
  })) : q = function(u) {
    return u instanceof this;
  };
  function U(l) {
    t = t || we();
    var u = this instanceof t;
    if (!u && !q.call(U, this)) return new U(l);
    this._writableState = new C(l, this, u), this.writable = !0, l && (typeof l.write == "function" && (this._write = l.write), typeof l.writev == "function" && (this._writev = l.writev), typeof l.destroy == "function" && (this._destroy = l.destroy), typeof l.final == "function" && (this._final = l.final)), o.call(this);
  }
  U.prototype.pipe = function() {
    j(this, new P());
  };
  function B(l, u) {
    var y = new L();
    j(l, y), $.nextTick(u, y);
  }
  function z(l, u, y, A) {
    var M;
    return y === null ? M = new O() : typeof y != "string" && !u.objectMode && (M = new m("chunk", ["string", "Buffer"], y)), M ? (j(l, M), $.nextTick(A, M), !1) : !0;
  }
  U.prototype.write = function(l, u, y) {
    var A = this._writableState, M = !1, n = !A.objectMode && d(l);
    return n && !a.isBuffer(l) && (l = c(l)), typeof u == "function" && (y = u, u = null), n ? u = "buffer" : u || (u = A.defaultEncoding), typeof y != "function" && (y = D), A.ending ? B(this, y) : (n || z(this, A, l, y)) && (A.pendingcb++, M = Y(this, A, n, l, u, y)), M;
  }, U.prototype.cork = function() {
    this._writableState.corked++;
  }, U.prototype.uncork = function() {
    var l = this._writableState;
    l.corked && (l.corked--, !l.writing && !l.corked && !l.bufferProcessing && l.bufferedRequest && K(this, l));
  }, U.prototype.setDefaultEncoding = function(u) {
    if (typeof u == "string" && (u = u.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((u + "").toLowerCase()) > -1)) throw new N(u);
    return this._writableState.defaultEncoding = u, this;
  }, Object.defineProperty(U.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function J(l, u, y) {
    return !l.objectMode && l.decodeStrings !== !1 && typeof u == "string" && (u = a.from(u, y)), u;
  }
  Object.defineProperty(U.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Y(l, u, y, A, M, n) {
    if (!y) {
      var i = J(u, A, M);
      A !== i && (y = !0, M = "buffer", A = i);
    }
    var b = u.objectMode ? 1 : A.length;
    u.length += b;
    var T = u.length < u.highWaterMark;
    if (T || (u.needDrain = !0), u.writing || u.corked) {
      var H = u.lastBufferedRequest;
      u.lastBufferedRequest = {
        chunk: A,
        encoding: M,
        isBuf: y,
        callback: n,
        next: null
      }, H ? H.next = u.lastBufferedRequest : u.bufferedRequest = u.lastBufferedRequest, u.bufferedRequestCount += 1;
    } else
      re(l, u, !1, b, A, M, n);
    return T;
  }
  function re(l, u, y, A, M, n, i) {
    u.writelen = A, u.writecb = i, u.writing = !0, u.sync = !0, u.destroyed ? u.onwrite(new E("write")) : y ? l._writev(M, u.onwrite) : l._write(M, n, u.onwrite), u.sync = !1;
  }
  function Z(l, u, y, A, M) {
    --u.pendingcb, y ? ($.nextTick(M, A), $.nextTick(h, l, u), l._writableState.errorEmitted = !0, j(l, A)) : (M(A), l._writableState.errorEmitted = !0, j(l, A), h(l, u));
  }
  function ne(l) {
    l.writing = !1, l.writecb = null, l.length -= l.writelen, l.writelen = 0;
  }
  function ie(l, u) {
    var y = l._writableState, A = y.sync, M = y.writecb;
    if (typeof M != "function") throw new S();
    if (ne(y), u) Z(l, y, A, u, M);
    else {
      var n = te(y) || l.destroyed;
      !n && !y.corked && !y.bufferProcessing && y.bufferedRequest && K(l, y), A ? $.nextTick(Q, l, y, n, M) : Q(l, y, n, M);
    }
  }
  function Q(l, u, y, A) {
    y || ee(l, u), u.pendingcb--, A(), h(l, u);
  }
  function ee(l, u) {
    u.length === 0 && u.needDrain && (u.needDrain = !1, l.emit("drain"));
  }
  function K(l, u) {
    u.bufferProcessing = !0;
    var y = u.bufferedRequest;
    if (l._writev && y && y.next) {
      var A = u.bufferedRequestCount, M = new Array(A), n = u.corkedRequestsFree;
      n.entry = y;
      for (var i = 0, b = !0; y; )
        M[i] = y, y.isBuf || (b = !1), y = y.next, i += 1;
      M.allBuffers = b, re(l, u, !0, u.length, M, "", n.finish), u.pendingcb++, u.lastBufferedRequest = null, n.next ? (u.corkedRequestsFree = n.next, n.next = null) : u.corkedRequestsFree = new e(u), u.bufferedRequestCount = 0;
    } else {
      for (; y; ) {
        var T = y.chunk, H = y.encoding, k = y.callback, x = u.objectMode ? 1 : T.length;
        if (re(l, u, !1, x, T, H, k), y = y.next, u.bufferedRequestCount--, u.writing)
          break;
      }
      y === null && (u.lastBufferedRequest = null);
    }
    u.bufferedRequest = y, u.bufferProcessing = !1;
  }
  U.prototype._write = function(l, u, y) {
    y(new I("_write()"));
  }, U.prototype._writev = null, U.prototype.end = function(l, u, y) {
    var A = this._writableState;
    return typeof l == "function" ? (y = l, l = null, u = null) : typeof u == "function" && (y = u, u = null), l != null && this.write(l, u), A.corked && (A.corked = 1, this.uncork()), A.ending || w(this, A, y), this;
  }, Object.defineProperty(U.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function te(l) {
    return l.ending && l.length === 0 && l.bufferedRequest === null && !l.finished && !l.writing;
  }
  function oe(l, u) {
    l._final(function(y) {
      u.pendingcb--, y && j(l, y), u.prefinished = !0, l.emit("prefinish"), h(l, u);
    });
  }
  function p(l, u) {
    !u.prefinished && !u.finalCalled && (typeof l._final == "function" && !u.destroyed ? (u.pendingcb++, u.finalCalled = !0, $.nextTick(oe, l, u)) : (u.prefinished = !0, l.emit("prefinish")));
  }
  function h(l, u) {
    var y = te(u);
    if (y && (p(l, u), u.pendingcb === 0 && (u.finished = !0, l.emit("finish"), u.autoDestroy))) {
      var A = l._readableState;
      (!A || A.autoDestroy && A.endEmitted) && l.destroy();
    }
    return y;
  }
  function w(l, u, y) {
    u.ending = !0, h(l, u), y && (u.finished ? $.nextTick(y) : l.once("finish", y)), u.ended = !0, l.writable = !1;
  }
  function F(l, u, y) {
    var A = l.entry;
    for (l.entry = null; A; ) {
      var M = A.callback;
      u.pendingcb--, M(y), A = A.next;
    }
    u.corkedRequestsFree.next = l;
  }
  return Object.defineProperty(U.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(u) {
      this._writableState && (this._writableState.destroyed = u);
    }
  }), U.prototype.destroy = s.destroy, U.prototype._undestroy = s.undestroy, U.prototype._destroy = function(l, u) {
    u(l);
  }, it;
}
var ot, nr;
function we() {
  if (nr) return ot;
  nr = 1;
  var e = Object.keys || function(v) {
    var _ = [];
    for (var R in v) _.push(R);
    return _;
  };
  ot = c;
  var t = $r(), r = kr();
  se(c, t);
  for (var o = e(r.prototype), a = 0; a < o.length; a++) {
    var f = o[a];
    c.prototype[f] || (c.prototype[f] = r.prototype[f]);
  }
  function c(v) {
    if (!(this instanceof c)) return new c(v);
    t.call(this, v), r.call(this, v), this.allowHalfOpen = !0, v && (v.readable === !1 && (this.readable = !1), v.writable === !1 && (this.writable = !1), v.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", d)));
  }
  Object.defineProperty(c.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(c.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(c.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function d() {
    this._writableState.ended || $.nextTick(s, this);
  }
  function s(v) {
    v.end();
  }
  return Object.defineProperty(c.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(_) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = _, this._writableState.destroyed = _);
    }
  }), ot;
}
var _t = {}, St = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(e, t) {
  var r = Ce, o = r.Buffer;
  function a(c, d) {
    for (var s in c)
      d[s] = c[s];
  }
  o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? e.exports = r : (a(r, t), t.Buffer = f);
  function f(c, d, s) {
    return o(c, d, s);
  }
  f.prototype = Object.create(o.prototype), a(o, f), f.from = function(c, d, s) {
    if (typeof c == "number")
      throw new TypeError("Argument must not be a number");
    return o(c, d, s);
  }, f.alloc = function(c, d, s) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    var v = o(c);
    return d !== void 0 ? typeof s == "string" ? v.fill(d, s) : v.fill(d) : v.fill(0), v;
  }, f.allocUnsafe = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return o(c);
  }, f.allocUnsafeSlow = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return r.SlowBuffer(c);
  };
})(St, St.exports);
var Mi = St.exports, Nt = Mi.Buffer, ir = Nt.isEncoding || function(e) {
  switch (e = "" + e, e && e.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function Li(e) {
  if (!e) return "utf8";
  for (var t; ; )
    switch (e) {
      case "utf8":
      case "utf-8":
        return "utf8";
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return "utf16le";
      case "latin1":
      case "binary":
        return "latin1";
      case "base64":
      case "ascii":
      case "hex":
        return e;
      default:
        if (t) return;
        e = ("" + e).toLowerCase(), t = !0;
    }
}
function Ni(e) {
  var t = Li(e);
  if (typeof t != "string" && (Nt.isEncoding === ir || !ir(e))) throw new Error("Unknown encoding: " + e);
  return t || e;
}
_t.StringDecoder = Re;
function Re(e) {
  this.encoding = Ni(e);
  var t;
  switch (this.encoding) {
    case "utf16le":
      this.text = Ui, this.end = ki, t = 4;
      break;
    case "utf8":
      this.fillLast = Bi, t = 4;
      break;
    case "base64":
      this.text = $i, this.end = Wi, t = 3;
      break;
    default:
      this.write = qi, this.end = xi;
      return;
  }
  this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Nt.allocUnsafe(t);
}
Re.prototype.write = function(e) {
  if (e.length === 0) return "";
  var t, r;
  if (this.lastNeed) {
    if (t = this.fillLast(e), t === void 0) return "";
    r = this.lastNeed, this.lastNeed = 0;
  } else
    r = 0;
  return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
};
Re.prototype.end = Fi;
Re.prototype.text = Ci;
Re.prototype.fillLast = function(e) {
  if (this.lastNeed <= e.length)
    return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
};
function at(e) {
  return e <= 127 ? 0 : e >> 5 === 6 ? 2 : e >> 4 === 14 ? 3 : e >> 3 === 30 ? 4 : e >> 6 === 2 ? -1 : -2;
}
function Ii(e, t, r) {
  var o = t.length - 1;
  if (o < r) return 0;
  var a = at(t[o]);
  return a >= 0 ? (a > 0 && (e.lastNeed = a - 1), a) : --o < r || a === -2 ? 0 : (a = at(t[o]), a >= 0 ? (a > 0 && (e.lastNeed = a - 2), a) : --o < r || a === -2 ? 0 : (a = at(t[o]), a >= 0 ? (a > 0 && (a === 2 ? a = 0 : e.lastNeed = a - 3), a) : 0));
}
function Di(e, t, r) {
  if ((t[0] & 192) !== 128)
    return e.lastNeed = 0, "�";
  if (e.lastNeed > 1 && t.length > 1) {
    if ((t[1] & 192) !== 128)
      return e.lastNeed = 1, "�";
    if (e.lastNeed > 2 && t.length > 2 && (t[2] & 192) !== 128)
      return e.lastNeed = 2, "�";
  }
}
function Bi(e) {
  var t = this.lastTotal - this.lastNeed, r = Di(this, e);
  if (r !== void 0) return r;
  if (this.lastNeed <= e.length)
    return e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  e.copy(this.lastChar, t, 0, e.length), this.lastNeed -= e.length;
}
function Ci(e, t) {
  var r = Ii(this, e, t);
  if (!this.lastNeed) return e.toString("utf8", t);
  this.lastTotal = r;
  var o = e.length - (r - this.lastNeed);
  return e.copy(this.lastChar, 0, o), e.toString("utf8", t, o);
}
function Fi(e) {
  var t = e && e.length ? this.write(e) : "";
  return this.lastNeed ? t + "�" : t;
}
function Ui(e, t) {
  if ((e.length - t) % 2 === 0) {
    var r = e.toString("utf16le", t);
    if (r) {
      var o = r.charCodeAt(r.length - 1);
      if (o >= 55296 && o <= 56319)
        return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
    }
    return r;
  }
  return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
}
function ki(e) {
  var t = e && e.length ? this.write(e) : "";
  if (this.lastNeed) {
    var r = this.lastTotal - this.lastNeed;
    return t + this.lastChar.toString("utf16le", 0, r);
  }
  return t;
}
function $i(e, t) {
  var r = (e.length - t) % 3;
  return r === 0 ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, r === 1 ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
}
function Wi(e) {
  var t = e && e.length ? this.write(e) : "";
  return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
}
function qi(e) {
  return e.toString(this.encoding);
}
function xi(e) {
  return e && e.length ? this.write(e) : "";
}
var ft, or;
function It() {
  if (or) return ft;
  or = 1;
  var e = _e().codes.ERR_STREAM_PREMATURE_CLOSE;
  function t(f) {
    var c = !1;
    return function() {
      if (!c) {
        c = !0;
        for (var d = arguments.length, s = new Array(d), v = 0; v < d; v++)
          s[v] = arguments[v];
        f.apply(this, s);
      }
    };
  }
  function r() {
  }
  function o(f) {
    return f.setHeader && typeof f.abort == "function";
  }
  function a(f, c, d) {
    if (typeof c == "function") return a(f, null, c);
    c || (c = {}), d = t(d || r);
    var s = c.readable || c.readable !== !1 && f.readable, v = c.writable || c.writable !== !1 && f.writable, _ = function() {
      f.writable || m();
    }, R = f._writableState && f._writableState.finished, m = function() {
      v = !1, R = !0, s || d.call(f);
    }, I = f._readableState && f._readableState.endEmitted, S = function() {
      s = !1, I = !0, v || d.call(f);
    }, P = function(N) {
      d.call(f, N);
    }, E = function() {
      var N;
      if (s && !I)
        return (!f._readableState || !f._readableState.ended) && (N = new e()), d.call(f, N);
      if (v && !R)
        return (!f._writableState || !f._writableState.ended) && (N = new e()), d.call(f, N);
    }, O = function() {
      f.req.on("finish", m);
    };
    return o(f) ? (f.on("complete", m), f.on("abort", E), f.req ? O() : f.on("request", O)) : v && !f._writableState && (f.on("end", _), f.on("close", _)), f.on("end", S), f.on("finish", m), c.error !== !1 && f.on("error", P), f.on("close", E), function() {
      f.removeListener("complete", m), f.removeListener("abort", E), f.removeListener("request", O), f.req && f.req.removeListener("finish", m), f.removeListener("end", _), f.removeListener("close", _), f.removeListener("finish", m), f.removeListener("end", S), f.removeListener("error", P), f.removeListener("close", E);
    };
  }
  return ft = a, ft;
}
var ut, ar;
function Gi() {
  if (ar) return ut;
  ar = 1;
  var e;
  function t(N, j, D) {
    return j = r(j), j in N ? Object.defineProperty(N, j, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : N[j] = D, N;
  }
  function r(N) {
    var j = o(N, "string");
    return typeof j == "symbol" ? j : String(j);
  }
  function o(N, j) {
    if (typeof N != "object" || N === null) return N;
    var D = N[Symbol.toPrimitive];
    if (D !== void 0) {
      var C = D.call(N, j || "default");
      if (typeof C != "object") return C;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (j === "string" ? String : Number)(N);
  }
  var a = It(), f = Symbol("lastResolve"), c = Symbol("lastReject"), d = Symbol("error"), s = Symbol("ended"), v = Symbol("lastPromise"), _ = Symbol("handlePromise"), R = Symbol("stream");
  function m(N, j) {
    return {
      value: N,
      done: j
    };
  }
  function I(N) {
    var j = N[f];
    if (j !== null) {
      var D = N[R].read();
      D !== null && (N[v] = null, N[f] = null, N[c] = null, j(m(D, !1)));
    }
  }
  function S(N) {
    $.nextTick(I, N);
  }
  function P(N, j) {
    return function(D, C) {
      N.then(function() {
        if (j[s]) {
          D(m(void 0, !0));
          return;
        }
        j[_](D, C);
      }, C);
    };
  }
  var E = Object.getPrototypeOf(function() {
  }), O = Object.setPrototypeOf((e = {
    get stream() {
      return this[R];
    },
    next: function() {
      var j = this, D = this[d];
      if (D !== null)
        return Promise.reject(D);
      if (this[s])
        return Promise.resolve(m(void 0, !0));
      if (this[R].destroyed)
        return new Promise(function(B, z) {
          $.nextTick(function() {
            j[d] ? z(j[d]) : B(m(void 0, !0));
          });
        });
      var C = this[v], q;
      if (C)
        q = new Promise(P(C, this));
      else {
        var U = this[R].read();
        if (U !== null)
          return Promise.resolve(m(U, !1));
        q = new Promise(this[_]);
      }
      return this[v] = q, q;
    }
  }, t(e, Symbol.asyncIterator, function() {
    return this;
  }), t(e, "return", function() {
    var j = this;
    return new Promise(function(D, C) {
      j[R].destroy(null, function(q) {
        if (q) {
          C(q);
          return;
        }
        D(m(void 0, !0));
      });
    });
  }), e), E), L = function(j) {
    var D, C = Object.create(O, (D = {}, t(D, R, {
      value: j,
      writable: !0
    }), t(D, f, {
      value: null,
      writable: !0
    }), t(D, c, {
      value: null,
      writable: !0
    }), t(D, d, {
      value: null,
      writable: !0
    }), t(D, s, {
      value: j._readableState.endEmitted,
      writable: !0
    }), t(D, _, {
      value: function(U, B) {
        var z = C[R].read();
        z ? (C[v] = null, C[f] = null, C[c] = null, U(m(z, !1))) : (C[f] = U, C[c] = B);
      },
      writable: !0
    }), D));
    return C[v] = null, a(j, function(q) {
      if (q && q.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var U = C[c];
        U !== null && (C[v] = null, C[f] = null, C[c] = null, U(q)), C[d] = q;
        return;
      }
      var B = C[f];
      B !== null && (C[v] = null, C[f] = null, C[c] = null, B(m(void 0, !0))), C[s] = !0;
    }), j.on("readable", S.bind(null, C)), C;
  };
  return ut = L, ut;
}
var lt, fr;
function Hi() {
  return fr || (fr = 1, lt = function() {
    throw new Error("Readable.from is not available in the browser");
  }), lt;
}
var st, ur;
function $r() {
  if (ur) return st;
  ur = 1, st = B;
  var e;
  B.ReadableState = U, At.EventEmitter;
  var t = function(i, b) {
    return i.listeners(b).length;
  }, r = wr(), o = Ce.Buffer, a = (typeof fe < "u" ? fe : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function f(n) {
    return o.from(n);
  }
  function c(n) {
    return o.isBuffer(n) || n instanceof a;
  }
  var d = Rt, s;
  d && d.debuglog ? s = d.debuglog("stream") : s = function() {
  };
  var v = Ti(), _ = Fr(), R = Ur(), m = R.getHighWaterMark, I = _e().codes, S = I.ERR_INVALID_ARG_TYPE, P = I.ERR_STREAM_PUSH_AFTER_EOF, E = I.ERR_METHOD_NOT_IMPLEMENTED, O = I.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, L, N, j;
  se(B, r);
  var D = _.errorOrDestroy, C = ["error", "close", "destroy", "pause", "resume"];
  function q(n, i, b) {
    if (typeof n.prependListener == "function") return n.prependListener(i, b);
    !n._events || !n._events[i] ? n.on(i, b) : Array.isArray(n._events[i]) ? n._events[i].unshift(b) : n._events[i] = [b, n._events[i]];
  }
  function U(n, i, b) {
    e = e || we(), n = n || {}, typeof b != "boolean" && (b = i instanceof e), this.objectMode = !!n.objectMode, b && (this.objectMode = this.objectMode || !!n.readableObjectMode), this.highWaterMark = m(this, n, "readableHighWaterMark", b), this.buffer = new v(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = n.emitClose !== !1, this.autoDestroy = !!n.autoDestroy, this.destroyed = !1, this.defaultEncoding = n.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, n.encoding && (L || (L = _t.StringDecoder), this.decoder = new L(n.encoding), this.encoding = n.encoding);
  }
  function B(n) {
    if (e = e || we(), !(this instanceof B)) return new B(n);
    var i = this instanceof e;
    this._readableState = new U(n, this, i), this.readable = !0, n && (typeof n.read == "function" && (this._read = n.read), typeof n.destroy == "function" && (this._destroy = n.destroy)), r.call(this);
  }
  Object.defineProperty(B.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(i) {
      this._readableState && (this._readableState.destroyed = i);
    }
  }), B.prototype.destroy = _.destroy, B.prototype._undestroy = _.undestroy, B.prototype._destroy = function(n, i) {
    i(n);
  }, B.prototype.push = function(n, i) {
    var b = this._readableState, T;
    return b.objectMode ? T = !0 : typeof n == "string" && (i = i || b.defaultEncoding, i !== b.encoding && (n = o.from(n, i), i = ""), T = !0), z(this, n, i, !1, T);
  }, B.prototype.unshift = function(n) {
    return z(this, n, null, !0, !1);
  };
  function z(n, i, b, T, H) {
    s("readableAddChunk", i);
    var k = n._readableState;
    if (i === null)
      k.reading = !1, ie(n, k);
    else {
      var x;
      if (H || (x = Y(k, i)), x)
        D(n, x);
      else if (k.objectMode || i && i.length > 0)
        if (typeof i != "string" && !k.objectMode && Object.getPrototypeOf(i) !== o.prototype && (i = f(i)), T)
          k.endEmitted ? D(n, new O()) : J(n, k, i, !0);
        else if (k.ended)
          D(n, new P());
        else {
          if (k.destroyed)
            return !1;
          k.reading = !1, k.decoder && !b ? (i = k.decoder.write(i), k.objectMode || i.length !== 0 ? J(n, k, i, !1) : K(n, k)) : J(n, k, i, !1);
        }
      else T || (k.reading = !1, K(n, k));
    }
    return !k.ended && (k.length < k.highWaterMark || k.length === 0);
  }
  function J(n, i, b, T) {
    i.flowing && i.length === 0 && !i.sync ? (i.awaitDrain = 0, n.emit("data", b)) : (i.length += i.objectMode ? 1 : b.length, T ? i.buffer.unshift(b) : i.buffer.push(b), i.needReadable && Q(n)), K(n, i);
  }
  function Y(n, i) {
    var b;
    return !c(i) && typeof i != "string" && i !== void 0 && !n.objectMode && (b = new S("chunk", ["string", "Buffer", "Uint8Array"], i)), b;
  }
  B.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, B.prototype.setEncoding = function(n) {
    L || (L = _t.StringDecoder);
    var i = new L(n);
    this._readableState.decoder = i, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var b = this._readableState.buffer.head, T = ""; b !== null; )
      T += i.write(b.data), b = b.next;
    return this._readableState.buffer.clear(), T !== "" && this._readableState.buffer.push(T), this._readableState.length = T.length, this;
  };
  var re = 1073741824;
  function Z(n) {
    return n >= re ? n = re : (n--, n |= n >>> 1, n |= n >>> 2, n |= n >>> 4, n |= n >>> 8, n |= n >>> 16, n++), n;
  }
  function ne(n, i) {
    return n <= 0 || i.length === 0 && i.ended ? 0 : i.objectMode ? 1 : n !== n ? i.flowing && i.length ? i.buffer.head.data.length : i.length : (n > i.highWaterMark && (i.highWaterMark = Z(n)), n <= i.length ? n : i.ended ? i.length : (i.needReadable = !0, 0));
  }
  B.prototype.read = function(n) {
    s("read", n), n = parseInt(n, 10);
    var i = this._readableState, b = n;
    if (n !== 0 && (i.emittedReadable = !1), n === 0 && i.needReadable && ((i.highWaterMark !== 0 ? i.length >= i.highWaterMark : i.length > 0) || i.ended))
      return s("read: emitReadable", i.length, i.ended), i.length === 0 && i.ended ? y(this) : Q(this), null;
    if (n = ne(n, i), n === 0 && i.ended)
      return i.length === 0 && y(this), null;
    var T = i.needReadable;
    s("need readable", T), (i.length === 0 || i.length - n < i.highWaterMark) && (T = !0, s("length less than watermark", T)), i.ended || i.reading ? (T = !1, s("reading or ended", T)) : T && (s("do read"), i.reading = !0, i.sync = !0, i.length === 0 && (i.needReadable = !0), this._read(i.highWaterMark), i.sync = !1, i.reading || (n = ne(b, i)));
    var H;
    return n > 0 ? H = u(n, i) : H = null, H === null ? (i.needReadable = i.length <= i.highWaterMark, n = 0) : (i.length -= n, i.awaitDrain = 0), i.length === 0 && (i.ended || (i.needReadable = !0), b !== n && i.ended && y(this)), H !== null && this.emit("data", H), H;
  };
  function ie(n, i) {
    if (s("onEofChunk"), !i.ended) {
      if (i.decoder) {
        var b = i.decoder.end();
        b && b.length && (i.buffer.push(b), i.length += i.objectMode ? 1 : b.length);
      }
      i.ended = !0, i.sync ? Q(n) : (i.needReadable = !1, i.emittedReadable || (i.emittedReadable = !0, ee(n)));
    }
  }
  function Q(n) {
    var i = n._readableState;
    s("emitReadable", i.needReadable, i.emittedReadable), i.needReadable = !1, i.emittedReadable || (s("emitReadable", i.flowing), i.emittedReadable = !0, $.nextTick(ee, n));
  }
  function ee(n) {
    var i = n._readableState;
    s("emitReadable_", i.destroyed, i.length, i.ended), !i.destroyed && (i.length || i.ended) && (n.emit("readable"), i.emittedReadable = !1), i.needReadable = !i.flowing && !i.ended && i.length <= i.highWaterMark, l(n);
  }
  function K(n, i) {
    i.readingMore || (i.readingMore = !0, $.nextTick(te, n, i));
  }
  function te(n, i) {
    for (; !i.reading && !i.ended && (i.length < i.highWaterMark || i.flowing && i.length === 0); ) {
      var b = i.length;
      if (s("maybeReadMore read 0"), n.read(0), b === i.length)
        break;
    }
    i.readingMore = !1;
  }
  B.prototype._read = function(n) {
    D(this, new E("_read()"));
  }, B.prototype.pipe = function(n, i) {
    var b = this, T = this._readableState;
    switch (T.pipesCount) {
      case 0:
        T.pipes = n;
        break;
      case 1:
        T.pipes = [T.pipes, n];
        break;
      default:
        T.pipes.push(n);
        break;
    }
    T.pipesCount += 1, s("pipe count=%d opts=%j", T.pipesCount, i);
    var H = (!i || i.end !== !1) && n !== $.stdout && n !== $.stderr, k = H ? ae : Se;
    T.endEmitted ? $.nextTick(k) : b.once("end", k), n.on("unpipe", x);
    function x(ce, de) {
      s("onunpipe"), ce === b && de && de.hasUnpiped === !1 && (de.hasUnpiped = !0, Bt());
    }
    function ae() {
      s("onend"), n.end();
    }
    var g = oe(b);
    n.on("drain", g);
    var Oe = !1;
    function Bt() {
      s("cleanup"), n.removeListener("close", We), n.removeListener("finish", qe), n.removeListener("drain", g), n.removeListener("error", $e), n.removeListener("unpipe", x), b.removeListener("end", ae), b.removeListener("end", Se), b.removeListener("data", Ct), Oe = !0, T.awaitDrain && (!n._writableState || n._writableState.needDrain) && g();
    }
    b.on("data", Ct);
    function Ct(ce) {
      s("ondata");
      var de = n.write(ce);
      s("dest.write", de), de === !1 && ((T.pipesCount === 1 && T.pipes === n || T.pipesCount > 1 && M(T.pipes, n) !== -1) && !Oe && (s("false write response, pause", T.awaitDrain), T.awaitDrain++), b.pause());
    }
    function $e(ce) {
      s("onerror", ce), Se(), n.removeListener("error", $e), t(n, "error") === 0 && D(n, ce);
    }
    q(n, "error", $e);
    function We() {
      n.removeListener("finish", qe), Se();
    }
    n.once("close", We);
    function qe() {
      s("onfinish"), n.removeListener("close", We), Se();
    }
    n.once("finish", qe);
    function Se() {
      s("unpipe"), b.unpipe(n);
    }
    return n.emit("pipe", b), T.flowing || (s("pipe resume"), b.resume()), n;
  };
  function oe(n) {
    return function() {
      var b = n._readableState;
      s("pipeOnDrain", b.awaitDrain), b.awaitDrain && b.awaitDrain--, b.awaitDrain === 0 && t(n, "data") && (b.flowing = !0, l(n));
    };
  }
  B.prototype.unpipe = function(n) {
    var i = this._readableState, b = {
      hasUnpiped: !1
    };
    if (i.pipesCount === 0) return this;
    if (i.pipesCount === 1)
      return n && n !== i.pipes ? this : (n || (n = i.pipes), i.pipes = null, i.pipesCount = 0, i.flowing = !1, n && n.emit("unpipe", this, b), this);
    if (!n) {
      var T = i.pipes, H = i.pipesCount;
      i.pipes = null, i.pipesCount = 0, i.flowing = !1;
      for (var k = 0; k < H; k++) T[k].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var x = M(i.pipes, n);
    return x === -1 ? this : (i.pipes.splice(x, 1), i.pipesCount -= 1, i.pipesCount === 1 && (i.pipes = i.pipes[0]), n.emit("unpipe", this, b), this);
  }, B.prototype.on = function(n, i) {
    var b = r.prototype.on.call(this, n, i), T = this._readableState;
    return n === "data" ? (T.readableListening = this.listenerCount("readable") > 0, T.flowing !== !1 && this.resume()) : n === "readable" && !T.endEmitted && !T.readableListening && (T.readableListening = T.needReadable = !0, T.flowing = !1, T.emittedReadable = !1, s("on readable", T.length, T.reading), T.length ? Q(this) : T.reading || $.nextTick(h, this)), b;
  }, B.prototype.addListener = B.prototype.on, B.prototype.removeListener = function(n, i) {
    var b = r.prototype.removeListener.call(this, n, i);
    return n === "readable" && $.nextTick(p, this), b;
  }, B.prototype.removeAllListeners = function(n) {
    var i = r.prototype.removeAllListeners.apply(this, arguments);
    return (n === "readable" || n === void 0) && $.nextTick(p, this), i;
  };
  function p(n) {
    var i = n._readableState;
    i.readableListening = n.listenerCount("readable") > 0, i.resumeScheduled && !i.paused ? i.flowing = !0 : n.listenerCount("data") > 0 && n.resume();
  }
  function h(n) {
    s("readable nexttick read 0"), n.read(0);
  }
  B.prototype.resume = function() {
    var n = this._readableState;
    return n.flowing || (s("resume"), n.flowing = !n.readableListening, w(this, n)), n.paused = !1, this;
  };
  function w(n, i) {
    i.resumeScheduled || (i.resumeScheduled = !0, $.nextTick(F, n, i));
  }
  function F(n, i) {
    s("resume", i.reading), i.reading || n.read(0), i.resumeScheduled = !1, n.emit("resume"), l(n), i.flowing && !i.reading && n.read(0);
  }
  B.prototype.pause = function() {
    return s("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (s("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function l(n) {
    var i = n._readableState;
    for (s("flow", i.flowing); i.flowing && n.read() !== null; ) ;
  }
  B.prototype.wrap = function(n) {
    var i = this, b = this._readableState, T = !1;
    n.on("end", function() {
      if (s("wrapped end"), b.decoder && !b.ended) {
        var x = b.decoder.end();
        x && x.length && i.push(x);
      }
      i.push(null);
    }), n.on("data", function(x) {
      if (s("wrapped data"), b.decoder && (x = b.decoder.write(x)), !(b.objectMode && x == null) && !(!b.objectMode && (!x || !x.length))) {
        var ae = i.push(x);
        ae || (T = !0, n.pause());
      }
    });
    for (var H in n)
      this[H] === void 0 && typeof n[H] == "function" && (this[H] = /* @__PURE__ */ function(ae) {
        return function() {
          return n[ae].apply(n, arguments);
        };
      }(H));
    for (var k = 0; k < C.length; k++)
      n.on(C[k], this.emit.bind(this, C[k]));
    return this._read = function(x) {
      s("wrapped _read", x), T && (T = !1, n.resume());
    }, this;
  }, typeof Symbol == "function" && (B.prototype[Symbol.asyncIterator] = function() {
    return N === void 0 && (N = Gi()), N(this);
  }), Object.defineProperty(B.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(B.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(B.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(i) {
      this._readableState && (this._readableState.flowing = i);
    }
  }), B._fromList = u, Object.defineProperty(B.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function u(n, i) {
    if (i.length === 0) return null;
    var b;
    return i.objectMode ? b = i.buffer.shift() : !n || n >= i.length ? (i.decoder ? b = i.buffer.join("") : i.buffer.length === 1 ? b = i.buffer.first() : b = i.buffer.concat(i.length), i.buffer.clear()) : b = i.buffer.consume(n, i.decoder), b;
  }
  function y(n) {
    var i = n._readableState;
    s("endReadable", i.endEmitted), i.endEmitted || (i.ended = !0, $.nextTick(A, i, n));
  }
  function A(n, i) {
    if (s("endReadableNT", n.endEmitted, n.length), !n.endEmitted && n.length === 0 && (n.endEmitted = !0, i.readable = !1, i.emit("end"), n.autoDestroy)) {
      var b = i._writableState;
      (!b || b.autoDestroy && b.finished) && i.destroy();
    }
  }
  typeof Symbol == "function" && (B.from = function(n, i) {
    return j === void 0 && (j = Hi()), j(B, n, i);
  });
  function M(n, i) {
    for (var b = 0, T = n.length; b < T; b++)
      if (n[b] === i) return b;
    return -1;
  }
  return st;
}
var ct, lr;
function Wr() {
  if (lr) return ct;
  lr = 1, ct = d;
  var e = _e().codes, t = e.ERR_METHOD_NOT_IMPLEMENTED, r = e.ERR_MULTIPLE_CALLBACK, o = e.ERR_TRANSFORM_ALREADY_TRANSFORMING, a = e.ERR_TRANSFORM_WITH_LENGTH_0, f = we();
  se(d, f);
  function c(_, R) {
    var m = this._transformState;
    m.transforming = !1;
    var I = m.writecb;
    if (I === null)
      return this.emit("error", new r());
    m.writechunk = null, m.writecb = null, R != null && this.push(R), I(_);
    var S = this._readableState;
    S.reading = !1, (S.needReadable || S.length < S.highWaterMark) && this._read(S.highWaterMark);
  }
  function d(_) {
    if (!(this instanceof d)) return new d(_);
    f.call(this, _), this._transformState = {
      afterTransform: c.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, _ && (typeof _.transform == "function" && (this._transform = _.transform), typeof _.flush == "function" && (this._flush = _.flush)), this.on("prefinish", s);
  }
  function s() {
    var _ = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(R, m) {
      v(_, R, m);
    }) : v(this, null, null);
  }
  d.prototype.push = function(_, R) {
    return this._transformState.needTransform = !1, f.prototype.push.call(this, _, R);
  }, d.prototype._transform = function(_, R, m) {
    m(new t("_transform()"));
  }, d.prototype._write = function(_, R, m) {
    var I = this._transformState;
    if (I.writecb = m, I.writechunk = _, I.writeencoding = R, !I.transforming) {
      var S = this._readableState;
      (I.needTransform || S.needReadable || S.length < S.highWaterMark) && this._read(S.highWaterMark);
    }
  }, d.prototype._read = function(_) {
    var R = this._transformState;
    R.writechunk !== null && !R.transforming ? (R.transforming = !0, this._transform(R.writechunk, R.writeencoding, R.afterTransform)) : R.needTransform = !0;
  }, d.prototype._destroy = function(_, R) {
    f.prototype._destroy.call(this, _, function(m) {
      R(m);
    });
  };
  function v(_, R, m) {
    if (R) return _.emit("error", R);
    if (m != null && _.push(m), _._writableState.length) throw new a();
    if (_._transformState.transforming) throw new o();
    return _.push(null);
  }
  return ct;
}
var dt, sr;
function Vi() {
  if (sr) return dt;
  sr = 1, dt = t;
  var e = Wr();
  se(t, e);
  function t(r) {
    if (!(this instanceof t)) return new t(r);
    e.call(this, r);
  }
  return t.prototype._transform = function(r, o, a) {
    a(null, r);
  }, dt;
}
var pt, cr;
function zi() {
  if (cr) return pt;
  cr = 1;
  var e;
  function t(m) {
    var I = !1;
    return function() {
      I || (I = !0, m.apply(void 0, arguments));
    };
  }
  var r = _e().codes, o = r.ERR_MISSING_ARGS, a = r.ERR_STREAM_DESTROYED;
  function f(m) {
    if (m) throw m;
  }
  function c(m) {
    return m.setHeader && typeof m.abort == "function";
  }
  function d(m, I, S, P) {
    P = t(P);
    var E = !1;
    m.on("close", function() {
      E = !0;
    }), e === void 0 && (e = It()), e(m, {
      readable: I,
      writable: S
    }, function(L) {
      if (L) return P(L);
      E = !0, P();
    });
    var O = !1;
    return function(L) {
      if (!E && !O) {
        if (O = !0, c(m)) return m.abort();
        if (typeof m.destroy == "function") return m.destroy();
        P(L || new a("pipe"));
      }
    };
  }
  function s(m) {
    m();
  }
  function v(m, I) {
    return m.pipe(I);
  }
  function _(m) {
    return !m.length || typeof m[m.length - 1] != "function" ? f : m.pop();
  }
  function R() {
    for (var m = arguments.length, I = new Array(m), S = 0; S < m; S++)
      I[S] = arguments[S];
    var P = _(I);
    if (Array.isArray(I[0]) && (I = I[0]), I.length < 2)
      throw new o("streams");
    var E, O = I.map(function(L, N) {
      var j = N < I.length - 1, D = N > 0;
      return d(L, j, D, function(C) {
        E || (E = C), C && O.forEach(s), !j && (O.forEach(s), P(E));
      });
    });
    return I.reduce(v);
  }
  return pt = R, pt;
}
var Zi = X, Dt = At.EventEmitter, Ki = se;
Ki(X, Dt);
X.Readable = $r();
X.Writable = kr();
X.Duplex = we();
X.Transform = Wr();
X.PassThrough = Vi();
X.finished = It();
X.pipeline = zi();
X.Stream = X;
function X() {
  Dt.call(this);
}
X.prototype.pipe = function(e, t) {
  var r = this;
  function o(_) {
    e.writable && e.write(_) === !1 && r.pause && r.pause();
  }
  r.on("data", o);
  function a() {
    r.readable && r.resume && r.resume();
  }
  e.on("drain", a), !e._isStdio && (!t || t.end !== !1) && (r.on("end", c), r.on("close", d));
  var f = !1;
  function c() {
    f || (f = !0, e.end());
  }
  function d() {
    f || (f = !0, typeof e.destroy == "function" && e.destroy());
  }
  function s(_) {
    if (v(), Dt.listenerCount(this, "error") === 0)
      throw _;
  }
  r.on("error", s), e.on("error", s);
  function v() {
    r.removeListener("data", o), e.removeListener("drain", a), r.removeListener("end", c), r.removeListener("close", d), r.removeListener("error", s), e.removeListener("error", s), r.removeListener("end", v), r.removeListener("close", v), e.removeListener("close", v);
  }
  return r.on("end", v), r.on("close", v), e.on("close", v), e.emit("pipe", r), e;
};
export {
  Mi as a,
  _t as b,
  Pi as c,
  At as e,
  se as i,
  Zi as s,
  Rt as u
};
//# sourceMappingURL=index-CzJutop_.mjs.map
